// Frontend environment configuration.
//
// Note: CRA inlines `process.env.REACT_APP_*` at build time. Runtime assignments
// here only help non-compiled code paths; the source of truth is `.env.*` files
// and `src/services/api.js#getApiBaseUrl`. We default dev to production so
// localhost can be used to test the full signed-in experience without a local
// backend.
const getEnvConfig = () => {
    const isProduction = process.env.NODE_ENV === 'production';

    if (isProduction) {
        return {
            REACT_APP_API_URL: 'https://api.blocknotify.com/v1',
            REACT_APP_GA_MEASUREMENT_ID: process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-WF90VJNDSR',
            NODE_ENV: 'production'
        };
    }

    // Development — point at prod by default so `npm start` on localhost
    // automatically hits production through the `/api` dev-server proxy.
    // Override with `.env.development` to target a local backend.
    return {
        REACT_APP_API_URL: 'https://api.blocknotify.com/v1',
        REACT_APP_GA_MEASUREMENT_ID: '', // Leave empty to disable in dev
        NODE_ENV: 'development'
    };
};

const envConfig = getEnvConfig();

// Set environment variables for React
Object.keys(envConfig).forEach(key => {
    if (!process.env[key]) {
        process.env[key] = envConfig[key];
    }
});

module.exports = envConfig; 